import { Page } from '@/core/architecture'

import { ConsoleFavoriteMemberCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleFavoriteMemberCreate Page
 * 推し登録画面
 */
export const ConsoleFavoriteMemberCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleFavoriteMemberCreateTemplate state={state} {...actions} />
}
